// extracted by mini-css-extract-plugin
export var buttonContainer = "_86-1";
export var fontSizeSelect = "_86-3";
export var formatSelect = "_86-2";
export var formats = "_86-4";
export var hidden = "_86-5";
export var icon = "_86-6";
export var select = "_86-0";